import { ErrorBoundary } from 'react-error-boundary';
import { CallLoggerPanel } from './CallLoggerPanel';
import { CallLoggerPanelError } from './CallLoggerPanelError';

export const SafeCallLoggerPanel = () => {
  return <ErrorBoundary FallbackComponent={CallLoggerPanelError}>
    <CallLoggerPanel></CallLoggerPanel>
  </ErrorBoundary>
}